import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.5
const Tiles = [
  {
    thumbnail_path: "/assets/images/gallery/placeholder/3-1.jpg",
    path: "/assets/images/gallery/3-1.jpg",
    position: {
      x: 0 + Start,
      y: -0.2
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "LOBBY CONCIERGE",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/3-2.jpg",
    path: "/assets/images/gallery/3-2.jpg",
    position: {
      x: 2.4 + Start,
      y: 0.2
    },
    title: {
      label:
        "A warm welcome whenever you come home with our 24/7 concierge. On hand to help you with your new life at Postmark, whether that’s taking in a parcel or giving advice on Farringdon’s best kept secret spots.",
      position: { x: 0, y: -0.1 }
    },
    caption: {
      label: "SWIMING POOL",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/3-3.jpg",
    path: "/assets/images/gallery/3-3.jpg",
    position: {
      x: 5 + Start,
      y: -0.18
    },
    title: {
      label: "",
      position: { x: 0, y: -0.1 }
    },
    caption: {
      label: "WELLNESS SPA",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/3-4.jpg",
    path: "/assets/images/gallery/3-4.jpg",
    position: {
      x: 7.6 + Start,
      y: 0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "STATE-OF-THE-ART GYM",
      position: { x: 0, y: 0 }
    }
  }
]

const TileData = {
  icon: TitleIcon,
  top: "3vw",
  left: "8vw",
  bottom: "auto",
  right: "auto",
  width: "55vw"
}

const AmenitiesGallery = () => <Gallery3D title={TileData} tiles={Tiles} length={10.1} />

export default AmenitiesGallery
